<template>
    <div class="modal_card">
        <div class="header">
            <h4 class="title">
                {{ translate('company_services.add_device_tariff') }}
            </h4>
        </div>
        <div class="content">

            <div class="row">
                <div class="col-md-12">
                    <label> {{ translate('company_services.tariff_name') }} </label>
                    <sis-select
                        :options="tariff_list"
                        :multiple="false"
                        v-model="tariff_id"
                        :placeholder="translate('company_services.tariff_name')"
                        :clearable="false"
                        :max_height="120"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-md-12" >
                    <fg-input
                        v-model="device_fid"
                        type="text"
                        :label="translate('company_services.device_fid')"
                        :placeholder="translate('company_services.device_fid')"
                    />
                </div>
            </div>

            <div class="text-center">
              <button
                class="btn btn-info btn-fill btn-wd"
                @click.prevent="add_device_tariff()"
              >
                {{ translate("support.add") }}
              </button>
              <button
                type="submit"
                class="btn btn-danger btn-fill btn-wd"
                @click.prevent="cancel"
              >
                Cancel
              </button>
            </div>
            <div class="clearfix" />
        </div>
    </div>
</template>
<script>

export default {
    name: "AddDeviceTariff",
    props: ['tariffs'],
    data () {
        return {
            tariff_id: null,
            device_fid: ''
        }
    },

    computed:{
        tariff_list(){
            let list = [{id: '', label: 'Not selected', isDisabled: true }]
            for (let tariff of this.tariffs) {
                list.push({ id: tariff.id, label: tariff.tariff_name })
            }
            return list
        },
    },

    created() {
    },

    methods: {
        cancel () {
            this.$emit('close')
        },
        add_device_tariff(){
            let new_device_tariff = {
                tariff_id: this.tariff_id,
                fid: this.device_fid
            }
            this.$emit('confirm', {...new_device_tariff})
        }

    }
}
</script>
<style lang="scss" scoped>
  .modal_card{
    width: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    padding: 10px;

    .header{
      .title{
        margin-top: 15px;
      }
    }
    .content{
      .text-center{
        margin-top: 100px;
      }
    }
  }

</style>
